import {Component, Input, OnInit} from '@angular/core';
import {ActionType, ObjectType, TrackChangeDetail} from '../../shared/types/track-changes/track-changes';
import {TrackChangesRestService} from '../../shared/services/track-changes/track-changes-rest.service';

@Component({
  selector: 'wsd-track-change',
  templateUrl: './track-change.component.html',
  styleUrls: ['./track-change.component.css']
})
export class TrackChangeComponent implements OnInit {

  @Input()
  id: number;

  @Input()
  objectType: ObjectType;

  @Input()
  actionType: ActionType;

  trackChangeDetail: TrackChangeDetail;

  showAddressSectionFlag: boolean = false;
  showTechnicalSectionFlag: boolean = false;
  showMembershipSectionFlag: boolean = false;
  showAppointmentsSectionFlag: boolean = false;
  showAppointeesSectionFlag: boolean = false;
  showContactsSectionFlag: boolean = false;

  constructor(private trackChangesRestService: TrackChangesRestService) {
  }

  ngOnInit() {
    this.fetchData();
  }

  isUpdate(): boolean {
    return this.actionType.toString() === ActionType[ActionType.UPDATE];
  }

  isCreate(): boolean {
    return this.actionType.toString() === ActionType[ActionType.CREATE];
  }

  isDelete(): boolean {
    return this.actionType.toString() === ActionType[ActionType.DELETE];
  }

  isOrganization(): boolean {
    return this.objectType.toString() === ObjectType[ObjectType.WSD_ORGANIZATION];
  }

  setShowTechnicalFlag() {
    if (this.showTechnicalSectionFlag) {
      return;
    }
    this.showTechnicalSectionFlag = true;
  }

  setShowContactsSectionFlag() {
    this.showContactsSectionFlag = true;
  }

  setShowAppointeesSectionFlag() {
    this.showAppointeesSectionFlag = true;
  }

  setShowAddressSectionFlag() {
    this.showAddressSectionFlag = true;
  }

  setShowAppointmentsSectionFlag() {
    this.showAppointmentsSectionFlag = true;
  }

  setShowMembershipSectionFlag() {
    this.showMembershipSectionFlag = true;
  }

  fetchData() {
    this.trackChangesRestService.getTrackChangesDetail(this.id).subscribe((data: any) => {
      this.trackChangeDetail = data;
      this.trackChangeDetail.oldData = JSON.parse(this.trackChangeDetail.oldData);
      this.trackChangeDetail.newData = JSON.parse(this.trackChangeDetail.newData);
    });
  }

  detectedSimpleArrayChange(arrayName: string): boolean {
    // this.trackChangeDetail.oldData = JSON.parse(this.trackChangeDetail.oldData);
    // this.trackChangeDetail.newData = JSON.parse(this.trackChangeDetail.newData);

      const oldDataList = this.trackChangeDetail.oldData[arrayName];
      let oldDataListFiltered;
      const newDataList = this.trackChangeDetail.newData[arrayName];
      let newDataListFiltered;

      if (oldDataList.length === 0 && newDataList.length === 0) {
        return false;
      }
      oldDataListFiltered = oldDataList.filter(a => {
        const newSimilar = newDataList.find(n => n.id === a.id);
        if (newSimilar === undefined) {
          return true;
        }
        for (const x of Object.keys(a)) {
          if (a[x] !== newSimilar[x] && (typeof a[x]) !== 'object') {
            return true;
          }
        }

        return false;
      });
      newDataListFiltered = newDataList.filter(a => {
        const newSimilar = oldDataList.find(n => n.id === a.id);
        if (newSimilar === undefined) {
          return true;
        }
        for (const x of Object.keys(a)) {
          if (a[x] !== newSimilar[x] && (typeof a[x]) !== 'object') {
            return true;
          }
        }
        return false;
      });

      if (newDataListFiltered.length > 0 || oldDataListFiltered.length > 0) {
        return true;
      }


  }

}
